// Set the key we'll use in local storage.
// Go to Chrome dev tools, application tab, click "Local Storage" and "http://localhost:8080"
// and you'll see this key set below (if logged in):
export const STORAGE_KEY = 'nexum-front';

let syncedData = {
  auth: {
    isLoggedIn: false,
    isLogging: false,
    loginError: false,
    loginErrorMsg: null,
    accessToken: null,
    refreshToken: null,
  },
  user: {
    name: null,
    employee: {
      department: {
        id: '',
        name: '',
      },
    },
  },
  employees: [],
};

const notSyncedData = {
  appnav: {
    searchText: '',
    searchTimestamp: null,
  },
  overlay: false,
  error: null,
  layout: {
    scrollY: 0,
    device: '',
    windowWidth: 0,
    windowHeight: 0,
  },
};

// Sync with local storage.
if (localStorage.getItem(STORAGE_KEY)) {
  syncedData = JSON.parse(localStorage.getItem(STORAGE_KEY));
}

// Merge data and export it.
export const state = Object.assign(syncedData, notSyncedData);



// WEBPACK FOOTER //
// ./src/store/state.js